/* eslint-disable no-mixed-operators */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Root } from './styled';

const ToolTip = props => {
  const { targetRef, children, margin, variant } = props;

  const toolTipRef = useRef();
  const [top, setTop] = useState(0);
  const [left, setLeft] = useState(0);
  const isReady = top > 0 && left > 0;

  useEffect(() => {
    if (targetRef.current && toolTipRef.current) {
      const { width: toolTipWidth } = toolTipRef.current.getBoundingClientRect();
      const {
        left: targetLeft,
        top: targetTop,
        width: targetWidth,
        height: targetHeight
      } = targetRef.current.getBoundingClientRect() || {};

      const halfToolTipWidth = toolTipWidth / 2;
      const halfTargetWidth = targetWidth / 2;

      const calculatedTop = targetTop + targetHeight + margin + window.scrollY;

      setTop(calculatedTop);
      setLeft(targetLeft - halfToolTipWidth + halfTargetWidth + window.scrollX);
    }
  }, [toolTipRef.current, targetRef.current, window.scrollX, window.scrollY]);

  if (!targetRef.current || !children) return null;

  return (
    <Root
      variant={variant}
      left={left}
      ref={toolTipRef}
      show={isReady}
      top={top}
    >
      {children}
    </Root>
  );
};

ToolTip.defaultProps = {
  margin: 8,
  variant: 'light'
};

ToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  margin: PropTypes.number,
  targetRef: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(['light', 'dark'])
};

export default ToolTip;



// WEBPACK FOOTER //
// ./components/tooltip/tooltip.js